import { render, staticRenderFns } from "./ic-tick-filled.vue?vue&type=template&id=157640c8&"
import script from "./ic-tick-filled.vue?vue&type=script&lang=js&"
export * from "./ic-tick-filled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports